/* eslint eqeqeq: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import {Field, reduxForm} from 'redux-form';
import CloseIcon from '../CloseIcon';
import { BODY_TEXT_COLOR, THIRD_COLOR, NEGATIVE_COLOR, ERROR_COLOR } from '../../config/colors';
import styled from 'styled-components';
import { getChangePasswordErrorDescription } from '../../helpers/errorDescriptions';
import './style.css';
import { hasUpperCase, hasLowerCase, hasNumbers } from '../../helpers/validators'

const $ = require("jquery");

/* validators begin */
const required = value => value ? undefined : 'Required'
const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
const maxLength15 = maxLength(15);
const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined
const minLength7 = minLength(7);

/* validators end */

const CONTAINER_HEIGHT = '100%';
const styles = {
    closeIconWrap: {"position":"absolute","right":"10px", top: '10px' },
    floatingText: {color: NEGATIVE_COLOR },
    textField: {width: '100%', fontSize: '16px', fontWeight:'400', color: BODY_TEXT_COLOR },
    underlineStyle: {borderColor: '#e6e6e6' },
    closeIcon: {height:'35px', width:'35px', color: THIRD_COLOR },
    labelStyle: { }
}

const validate = values => {
  const errors = {}
  if (values.password !== values.password2) {
    errors.password2 = 'Passwords Do Not Match';
  }
  if (values.password === values.currentpassword || values.password2 === values.currentpassword) {
    errors.currentpassword = 'New password can`t be the same as current one';
    errors.password = 'New password can`t be the same as current one';
    errors.password1 = 'New password can`t be the same as current one';
  }
  return errors
}
class ChangedPasswordForm extends Component {
 
    passwordField = null;
    fields = {
        'email': null,
        'password': null
    }

    secondaryColor = ['#',this.props.secondaryColor].join('');
    floatingLabelStyle = { color: this.secondaryColor };
    floatingFocusLabelStyle = { color: this.secondaryColor };
    underlineFocusStyle = { borderColor: this.secondaryColor };

    state = {
        isOpen: true,
        isInputAddressActive: false,
        inputNameFocused: null,
        mainContainerHeight: CONTAINER_HEIGHT,
    }

    handleInputEnterPress = (e,  inputName, touched, error) => {
        if ((e.key === 'Enter' || e.key == '13') && error === undefined) {
            if (inputName === 'email') {
                e.preventDefault();
                this.onInputBlur('email');
                setTimeout(()=>{
                    this.passwordField.focus();
                },250);
            } else if (inputName === 'password') {
                this.props.handleSubmit();
            }
        }
    }

    onInputFocus = (inputName) => {
        const { isPhone, is_iPhone } = this.props;
        if (is_iPhone) return;
        if (isPhone) {
            const height = [$('.greetigs').height()/2,'px']; 
            this.setState({
                isInputAddressActive: true,
                inputNameFocused: inputName,
                mainContainerHeight: height.join('')
            })
        }
    }

    onInputBlur = (inputName) => {
        const { isPhone, is_iPhone } = this.props;
        if (is_iPhone) return;
        if (isPhone) {
            this.setState({
                isInputAddressActive: false,
                inputNameFocused: null,
                mainContainerHeight: CONTAINER_HEIGHT
            })  
        }    
    }

   renderCurrentPasswordField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={input => this.passwordField = input}
            type="password"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'currentpassword', touched, error)}
            onFocus={()=>this.onInputFocus('currentpassword')}
            onBlur={()=>this.onInputBlur('currentpassword')}
            floatingLabelText={<span style={styles.floatingText}>Current Password</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingLabelFocusStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    )

   renderPasswordField = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={input => this.passwordField = input}
            type="password"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'password', touched, error)}
            onFocus={()=>this.onInputFocus('password')}
            onBlur={()=>this.onInputBlur('password')}
            floatingLabelText={<span style={styles.floatingText}>New Password</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingLabelFocusStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    )

   renderPasswordField2 = ({input, label, meta: {touched, error}, ...custom}) => (
        <TextField
            ref={input => this.passwordField = input}
            type="password"
            onKeyPress={(e) => this.handleInputEnterPress(e, 'password2', touched, error)}
            onFocus={()=>this.onInputFocus('password2')}
            onBlur={()=>this.onInputBlur('password2')}
            floatingLabelText={<span style={styles.floatingText}>Confirm New Password</span>}
            style={styles.textField}
            floatingLabelStyle={this.floatingLabelStyle}
            floatingLabelFocusStyle={this.floatingLabelFocusStyle}
            underlineStyle={styles.underlineStyle}
            underlineFocusStyle={this.underlineFocusStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    );

  renderApiError = () => {
    if (!this.props.signup.errors.changePassword) return null;
    let text = getChangePasswordErrorDescription(this.props.signup.errors.changePassword);
    return (
      <ErrorDiv>
        {text}
      </ErrorDiv>
    );
  }

  render() {
   const {handleSubmit, error } = this.props;
    return (
        <form name="loginform" onSubmit={handleSubmit}>
        <div onClick={this.props.onCloseRequest} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} /></div>
            <FormWrapperDiv style={{height: this.state.mainContainerHeight}}>
                <div style={{width:'100%'}}>
                    <HeaderTitle>Change Password</HeaderTitle>
                    <HorLine />
                </div>

                 <div className="login-input">
                    <Field 
                        name="currentpassword" 
                        validate={[ required, minLength7, maxLength15, hasLowerCase, hasUpperCase, hasNumbers ]}
                        component={this.renderCurrentPasswordField} />
                </div>
                <div className="login-input">
                    <Field 
                        name="password" 
                        validate={[ required, minLength7, maxLength15, hasLowerCase, hasUpperCase, hasNumbers ]}
                        component={this.renderPasswordField} />
                </div>
                <div className="login-input">
                    <Field 
                        name="password2" 
                        validate={[ required, minLength7, maxLength15  ]}
                        component={this.renderPasswordField2} />
                </div>
                {error}
                {this.renderApiError()}
                <ButtonsWrapperDiv>
                    <LeftDiv><ButtonDiv onClick={this.props.onCloseRequest}>Cancel</ButtonDiv></LeftDiv>
                    <RightDiv><ButtonDiv onClick={handleSubmit} color={`#` + this.props.secondaryColor}>Save</ButtonDiv></RightDiv>
                </ButtonsWrapperDiv>
            </FormWrapperDiv>
        </form>
    );
  }
}

ChangedPasswordForm = reduxForm({
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'ChangedPasswordForm',
  validate
})(ChangedPasswordForm)

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    signup: state.signup
  };
};

export default connect(mapStateToProps, null)(ChangedPasswordForm);

// const HeaderDiv = styled.div `
//   font-size: 39px;
//   line-height: 39px;
//   font-weight: 700;
//   font-family: 'Futura-Bold';
//   text-align: center;
//     @media (max-width: 320px) {
//         font-size: 35px;
//         line-height: 35px;
//     }
// `;

const FormWrapperDiv = styled.div `
    display: flex;
    color: ${BODY_TEXT_COLOR};
    flex-direction: column;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0;
    height: 100%;
    font-family: 'Futura-Bold', 'Futura-Bold';
`;

const HeaderTitle = styled.div `
  text-align: center;
  margin-top: 18px;
  font-size: 21px;
  font-weight: 800;
  font-family: 'Futura-Bold';
  color: ${BODY_TEXT_COLOR};
`

const HorLine = styled.hr `
    display: block;
    height: 2px;
    border: 0;
    border-top: 2px solid #f4f4f4;
    margin: 1em 0 0;
    padding: 0;
`;

const ButtonsWrapperDiv = styled.div `
  margin-top: 30px;
  height: 50px;
  width: 100%;
  border-top: 1px solid #E6E6E7;
`;

const LeftDiv = styled.div `
    float:left; 
    width: 50%;
    background-color: #fff;
    height: 100%;
    border-right: 1px solid #E6E6E7;
    box-sizing: border-box;
`;

const RightDiv = styled.div `
    float: right;
    background-color: #fff;
    height: 100%;
    width: 50%;
`;

const ErrorDiv = styled.div `
  color: ${ERROR_COLOR}
`;

const ButtonDiv = styled.div `
    font-family: 'Roboto';
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding: 15px;
    color: ${props => {
      if (props.disabled) {
        return "#E6E6E7"
      } else if (props.color) {
        return props.color;
      } else {
        return '#616161';
      }
    }};
`;



// WEBPACK FOOTER //
// ./src/components/ChangedPasswordForm/ChangedPasswordForm.jsx